import { useId } from "react";
import { useLocalBack } from "../navigation";
import { t } from "../preferences";

export function LogoutConfirmation({ onCancel, onConfirm }: { onCancel: () => void; onConfirm: () => void }) {
  const titleId = useId();
  useLocalBack(true, onCancel);
  return <div className="m-fixed m-inset-0 m-z-[80] m-flex m-items-center m-justify-center m-bg-black/50 m-p-4">
    <section role="alertdialog" aria-modal="true" aria-labelledby={titleId} className="m-w-full m-max-w-sm m-rounded-2xl m-bg-surface m-p-5" onKeyDown={event => {
      if (event.key !== "Tab") return;
      const buttons = event.currentTarget.querySelectorAll<HTMLButtonElement>("button");
      if (event.shiftKey && document.activeElement === buttons[0]) { event.preventDefault(); buttons[1].focus(); }
      else if (!event.shiftKey && document.activeElement === buttons[1]) { event.preventDefault(); buttons[0].focus(); }
    }}>
      <h2 id={titleId} className="m-text-xl m-font-bold">{t("Akkauntdan chiqmoqchimisiz?", "Вы хотите выйти из аккаунта?")}</h2>
      <div className="m-mt-5 m-grid m-grid-cols-2 m-gap-3">
        <button autoFocus type="button" className="m-secondary-button" onClick={onCancel}>{t("Bekor qilish")}</button>
        <button type="button" className="m-primary-button m-bg-danger" onClick={onConfirm}>{t("Chiqish")}</button>
      </div>
    </section>
  </div>;
}
